export default __webpack_public_path__ + "static/media/fasting_water@2x.3c673751.jpg";